import React from "react";
import data from "../../femcare-content.json";
import ImageCardGrid from "../common/WhyImageCard";
// import { ServiceCard } from "../Programs/WhoThisIsForCards";

const { whyTrustUs } = data.sections;

const WhyTrustUs = () => {
  const { id, heading, items } = whyTrustUs;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      {/* Heading */}
      <div
        className=" ava-pl-spacing"
      >
        <h2
          className="ava-heading-lg ava-heading-gap">
          {heading}
        </h2>
      </div>

      {/* Responsive Grid */}
      <div className=" ava-pl-spacing ava-pr-spacing">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ava-card-gap">
          {items.map((item) => (
            <ServiceCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};


const ServiceCard = ({ item }) => {
  return (
    <div className="bg-white ava-card-mukta shadow-sm ava-radius-md  flex flex-col overflow-hidden ">
      {/* Image */}
      <div className="">
        <img
          src={item.image}
          alt={item.label || item.title}
          className="w-full object-cover transition-transform duration-500 h-[200px] ava-radius-md"
        />
        {/* ✅ Label ONLY if exists */}
        {/* {item.imgicon && (
          <div className="absolute top-0 left-0 flex items-center gap-2 px-3 py-3 bg-white text-white text-xs rounded-br-[10px]">
            <img src={item.imgicon} alt="" className=""  />
            <span>{item.label}</span>
          </div>
        )} */}
      </div>

      {/* Content */}
      <div className="w-full px-4 py-4 ava-card-bg flex flex-col justify-start flex-1" >
        <p
          className="ava-text-subheading  "
        >
          {item.description}
        </p>
      </div>
    </div>
  );
};
/* Feature Card (using SVG from public folder) */
// const FeatureCard = ({ item }) => {
//   return (
//     <div className="flex flex-col items-start p-4 md:p-5 gap-2 rounded-2xl ava-card-bg transition-all duration-300">
//       {/* Image - Enlarged */}
//       <div className="w-full">
//         <img
//           src={item.image}
//           alt={item.title}
//           className="w-full h-40 md:h-44 lg:h-48 object-cover rounded-lg"
//           draggable={false}
//         />
//       </div>

//       {/* Text */}
//       <div className="flex flex-col gap-1">
//         <h3
//           className="ava-text-subheading"
//           style={{
//             // fontSize: "clamp(0.8rem, 1.4vw, 0.9rem)",
//           }}
//         >
//           {item.title}
//         </h3>

//         <p
//           className=" ava-text-body"
//           style={{
//             // fontSize: "clamp(0.8rem, 1vw, 0.9rem)",
//           }}
//         >
//           {item.description}
//         </p>
//       </div>
//     </div>
//   );
// };

export default WhyTrustUs;

// import React from 'react';
// import data from '../../femcare-content.json';

// const { whyTrustUs } = data.sections;

// const WhyTrustUs = () => {
//   const { id, heading, items, sideImage } = whyTrustUs;

//   return (
//     <section id={id} className="w-full bg-white overflow-hidden">

//       {/* ── Heading ── */}
//       <div style={{ paddingLeft: 'clamp(1.5rem, 5vw, 4rem)', paddingRight: '1rem' }}>
//         <h2
//           className="font-bold mb-8 md:mb-10"
//           style={{ color: 'var(--primary-color)', fontSize: 'clamp(1.3rem, 2.8vw, 2rem)' }}
//         >
//           {heading}
//         </h2>
//       </div>

//       {/* ══════════════════════════════════════════════════════
//           MOBILE + TABLET  (< 1024px):
//             Cards only, full width, NO side image, no large gap
//           DESKTOP          (≥ 1024px):
//             Original layout — cards left + side image right
//       ══════════════════════════════════════════════════════ */}

//       {/* ── Mobile & Tablet: cards only ── */}
//       <div className="lg:hidden flex flex-col gap-3 px-4 md:px-8">
//         {items.map((item) => (
//           <FeatureCard key={item.id} item={item} />
//         ))}
//       </div>

//       {/* ── Desktop only: original two-column layout ── */}
//       <div
//         className="hidden lg:flex flex-row"
//         style={{
//           alignItems: 'stretch',
//           paddingLeft: 'clamp(6rem, 16vw, 16rem)',
//           minHeight: '380px',
//           maxHeight: '420px',
//         }}
//       >
//         {/* Left — Cards */}
//         <div
//           className="flex flex-col"
//           style={{ flex: '0 0 48%', paddingRight: '2rem', gap: '12px' }}
//         >
//           {items.map((item) => (
//             <FeatureCard key={item.id} item={item} />
//           ))}
//         </div>

//         {/* Right — Side image flush to right edge */}
//         <div
//           style={{
//             flex: '1',
//             borderRadius: '1.25rem 0 0 1.25rem',
//             overflow: 'hidden',
//             minHeight: '380px',
//             maxHeight: '420px',
//           }}
//         >
//           <img
//             src={sideImage.src}
//             alt={sideImage.alt}
//             style={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               objectPosition: 'center',
//               display: 'block',
//             }}
//             draggable={false}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// /* ── Feature Card — unchanged ── */
// const FeatureCard = ({ item }) => (
//   <div
//     className="flex items-center gap-4 ava-card-bg"
//     style={{
//       flex: '1 1 0%',
//       borderRadius: '1rem',
//       padding: '12px 16px 12px 12px',
//       minHeight: '90px',
//     }}
//   >
//     {/* Thumbnail */}
//     <div
//       style={{
//         flexShrink: 0,
//         width: '100px',
//         height: '70px',
//         borderRadius: '0.6rem',
//         overflow: 'hidden',
//       }}
//     >
//       <img
//         src={item.image}
//         alt={item.title}
//         style={{
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover',
//           objectPosition: 'center',
//           display: 'block',
//         }}
//         draggable={false}
//       />
//     </div>

//     {/* Text */}
//     <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//       <h3
//         style={{
//           color: 'var(--primary-color)',
//           fontWeight: 600,
//           fontSize: 'clamp(0.85rem, 1.1vw, 1rem)',
//           margin: 0,
//         }}
//       >
//         {item.title}
//       </h3>
//       <p
//         className="primary-text"
//         style={{ fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)', margin: 0 }}
//       >
//         {item.description}
//       </p>
//     </div>
//   </div>
// );

// export default WhyTrustUs;
